import { join } from 'juriquery'

type DefaultAuthRouteParams = {
  referrer?: string
  organization?: string
}

export const AUTH_LOGIN_ROUTE = `/login`
export const LOGIN_SIGN_IN_ROUTE = `/signin`
export const AUTH_LOGOUT_ROUTE = `/logout`
export const AUTH_INACTIVITY_ROUTE = `/inactivity`
export const AUTH_RESET_PASSWORD_ROUTE = `/reset-password`
export const LOGIN_ACTIVATED_ROUTE = `/activated`
export const LOGIN_ACTIVATION_ROUTE = `/activation`
export const LOGIN_PASSWORD_ROUTE = `/password`
export const LOGIN_CHANGE_EMAIL_ROUTE = `/change-email`
export const AUTH_EXCHANGE_ROUTE = `/exchange`
export const AUTH_MFA_VERIFY_ROUTE = '/mfa-verify'
export const AUTH_MFA_SETUP_ROUTE = '/mfa-setup'
export const AUTH_CALLBACKS_MOBILE_ROUTE = '/callbacks/mobile'

export const getAuthLoginRoute = () => AUTH_LOGIN_ROUTE

export const getAuthInactivityRoute = ({
  referrer,
}: { referrer?: string } = {}) =>
  join(`${getAuthLoginRoute()}${AUTH_INACTIVITY_ROUTE}`, { referrer })

export const getAuthLogoutRoute = (reason?: string) =>
  join(`${AUTH_LOGOUT_ROUTE}`, { reason })

export const getAuthRootRoute = () => '/'
export const getAuthMfaSetupRoute = ({
  referrer,
  organization,
}: DefaultAuthRouteParams = {}) =>
  join(AUTH_MFA_SETUP_ROUTE, { referrer, organization })
export const getAuthMfaVerifyRoute = ({
  referrer,
  organization,
}: DefaultAuthRouteParams = {}) =>
  join(AUTH_MFA_VERIFY_ROUTE, { referrer, organization })
export const getAuthResetPasswordRoute = () => AUTH_RESET_PASSWORD_ROUTE

export const getStandaloneLoginRoute = ({
  referrer,
  reason,
  organization,
}: {
  referrer?: string
  reason?: string
  organization?: string
} = {}) => {
  // We need this due to the fact that we build only once for both staging and production,
  // it is the same pattern as we use in the ApiResolver
  if (
    window.location.origin.includes('app.staging.surglogs.com') ||
    !process.env.REACT_APP_AUTH_URL
  ) {
    return join(window.location.origin.replace('app', 'auth'), {
      referrer,
      reason,
      organization,
    })
  }

  return join(process.env.REACT_APP_AUTH_URL, {
    referrer,
    reason,
    organization,
  })
}

export const getWebAppLoginExchangeUrl = (
  transactionId: string,
  code: string,
  appUrl: string,
) =>
  join(`${appUrl}${getAuthLoginRoute()}${AUTH_EXCHANGE_ROUTE}`, {
    transaction_id: transactionId,
    code,
  })

export const getLoginCallbacksMobileRoute = (
  transactionId: string,
  code: string,
) =>
  join(`${getAuthLoginRoute()}${AUTH_CALLBACKS_MOBILE_ROUTE}`, {
    transaction_id: transactionId,
    code,
  })

export const getCorporateDashboardLoginExchangeUrl = (
  transactionId: string,
  code: string,
  appUrl: string,
) =>
  join(`${appUrl}${AUTH_EXCHANGE_ROUTE}`, {
    transaction_id: transactionId,
    code,
  })
